import { defaultRules } from '../rules/default-rules.js';
import { headerRules } from '../rules/header-rules.js';
import { footerRules } from '../rules/footer-rules.js';
import { midRules } from '../rules/mid-rules.js';
import { islandRules } from '../rules/island-rules.js';
import { computeConstraintsRules } from '../rules/compute-constraints-rules.js';
import { mobileRules } from '../rules/mobile-rules.js';
import { partShowRules } from '../rules/part-show-rules.js';
import { expandedRules } from '../rules/expanded-rules.js';
import { behaviorRules } from '../rules/behavior-rules.js';
import { sandboxRules } from '../rules/sandbox-rules.js';
import { positionRules } from '../rules/position-rules.js';
import { horizontalRules } from '../rules/horizontal-rules.js';
import { brandSponsoredRules } from '../rules/brand-sponsored-rules.js';
import { t0Rules } from '../rules/t0-rules.js';
import { certificateUrlRules } from '../rules/certificate-url-rules.js';
import { d2cRules } from '../rules/d2c-rules.js';
import { productRules } from '../rules/product-rules.js';

/**
 * Defines the badges as we know them (standard rules).
 * Rules have been roughly grouped and extracted in external files for easier maintenance.
 *
 * @param {BadgeComposition} composition
 * @returns {BadgeCompositionRule[]}
 */
export const standardBadgeBuilder = composition => [
  // defaults for all/most cases
  ...defaultRules(composition),

  // basic config for each variant
  ...headerRules(composition),
  ...midRules(composition),
  ...islandRules(composition),
  ...footerRules(composition),

  // compute different functional aspects
  ...computeConstraintsRules(composition),
  ...mobileRules(composition),
  ...horizontalRules(composition),
  ...expandedRules(composition),
  ...sandboxRules(composition),
  ...t0Rules(composition),
  ...certificateUrlRules(composition),

  // final rules that depend on previous definitions
  ...partShowRules(composition),
  ...positionRules(composition),
  ...behaviorRules(composition),
  ...brandSponsoredRules(composition),
  ...d2cRules(composition),
  ...productRules(composition)
];
